import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import menus from "../menu";

class Header extends Component {
  render() {
    const { location } = this.props;
    return (
      <header id="site-header">
        <div id="site-header-inner" className="container">
          <div className="wrap-inner clearfix">
            <div id="site-logo" className="clearfix">
              <div id="site-log-inner">
                <a href="/">
                  <img
                    src={this.props.data.logoweb}
                    alt="CityX Apps"
                    width={140}
                    height={50}
                    data-retina="/assets/img/logo-cityx@2x.png"
                    data-width={140}
                    data-height={50}
                  />
                </a>
              </div>
            </div>
            <div className="mobile-button">
              <span />
            </div>
            <nav id="main-nav" className="main-nav">
              <ul id="menu-primary-menu" className="menu">
                {menus.map((data) => (
                  <li
                    className={
                      data.name === this.props.data.names
                        ? "menu-item menu-item-has-children current-menu-item"
                        : "menu-item menu-item-has-children"
                    }
                    key={data.id}
                  >
                    {!data?.namesub ? (
                      <a href={data.links}>{data.name}</a>
                    ) : (
                      <>
                        <Link to="#">{data.name}</Link>
                        <ul className="sub-menu">
                          {data.namesub.map((submenu) => (
                            <li
                              className={
                                location.pathname === submenu.links
                                  ? "menu-item current-item"
                                  : "menu-item"
                              }
                              key={submenu.id}
                            >
                              {submenu.disabled ? (
                                <a
                                  href={submenu.links}
                                  style={{
                                    pointerEvents: "none",
                                    cursor: "default",
                                    opacity: 0.3,
                                  }}
                                >
                                  {submenu.sub}
                                </a>
                              ) : (
                                <a href={submenu.links}>{submenu.sub}</a>
                              )}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
            <div id="header-search" style={{ display: "none" }}>
              <Link to="#" className="header-search-icon">
                <span className="search-icon fa fa-search"></span>
              </Link>
              <form
                role="search"
                method="get"
                className="header-search-form"
                action="#"
              >
                <label className="screen-reader-text">Search for:</label>
                <input
                  type="text"
                  defaultValue
                  name="s"
                  className="header-search-field"
                  placeholder="Search..."
                />
                <button
                  type="submit"
                  className="header-search-submit"
                  title="Search"
                >
                  <i className="fa fa-search" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);
